import { Flex, Grid, GridItem, Heading, Link, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import { ReactComponent as Github } from "../../assets/icons/github-mark.svg";
import ProjectItem from "./ProjectItem";
import MyPage from '../../assets/img/my_page.png';
import Flight from '../../assets/img/flight.jpg';
import Elisabeth from '../../assets/img/elisabeth.png';

const projects = [
    {
        title: 'My Portfolio',
        when: '2024',
        img: MyPage,
        description: 'I created this page to showcase my work. I will also use this page as my creative space where I can try and test technologies.',
        tags: ['Figma', 'React']
    },
    {
        title: 'Flight App',
        when: '2022',
        img: Flight,
        description: 'A friend asked me for a PoC to show how information can be pulled from a flight API. The purpose was to notify co-workers about changes in incoming flights so they can act faster. We wanted to make use of Google Assistant and Nest integration.',
        tags: ['dialogflow', 'poc']
    },
    {
        title: 'Elisabeth Falkemo',
        when: '2022-2023',
        img: Elisabeth,
        description: 'Elisabeth Falkmo is an HR consultant and an author. She wanted a personal website to advertise her book and her services. To give her the control and freedom to change the content, Sanity, as a headless CMS, was chosen.',
        tags: ['Sanity', 'React']
    }
];

const Projects = () => {
    const [onHover, setOnHover] = useState(false);
    return (
        <Grid gridTemplateColumns={{ base: "1fr", lg: "repeat(4, 1fr)" }} gap={4}>
            <GridItem><Heading as="h2" fontSize={['4xl', '5xl']}>My Projects</Heading></GridItem>
            <GridItem colSpan={{ base: 1, lg: 3 }} display={{ base: "none", lg: "block" }}></GridItem>
            <GridItem gap="4" display="flex" flexDirection="column">
                <Text>Here are a few projects I'm proud to share with you. Additionally, I have several exciting ideas for future projects that I'd love to discuss over a coffee ☕️</Text>
                <Text>It's not just about technology; I also explore concepts related to furniture design and home decor.</Text>
                <Link
                    href="https://github.com/cecla"
                    color="secondary.1"
                    _hover={{
                        textDecoration: 'none',
                        color: 'secondary.2'
                    }}
                    onMouseEnter={() => setOnHover(true)}
                    onMouseLeave={() => setOnHover(false)}
                >
                    <Flex alignItems="center" gap="1rem" my={3}>
                        <Github fill={onHover ? "#627E9A" : "#96B2D1"} height="32px" width="32px" />
                        <Text color="inherit">Just a few more projects.<br />Side projects and school projects.</Text>
                    </Flex>
                </Link>
            </GridItem>
            {projects.map(item => <ProjectItem item={item} />)}
        </Grid >
    );
};

export default Projects;